import { useMediaQuery } from '@mui/material'
import src from '../assets/bridge-academy.png'
import {motion} from 'framer-motion'
import {ChevronLeft, ChevronRight} from 'lucide-react'
import { useRef , useState , useEffect } from 'react'
export default function AcademySection() {
    const scrollref = useRef(null)
    const titles = ['Cloud Fundamentals','Amzaon Web Services','OpenStack','Docker','Kubernetes Fundamentals','Kubernetes Advanced','Multi Cluster Management','CI/CD Jenkins','CI/CD GitLab','CD - ARGO & FLUX']
    const descriptions = ['Cloud Computing','Cloud Computing','Cloud Computing','Containers','Containers','Containers','DevOps','DevOps','DevOps','DevOps']
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    
    //verify scroll position
    const checkScrollPosition = () => {
        if (!scrollref.current) return;
        const { scrollLeft, scrollWidth, clientWidth } = scrollref.current;
        setCanScrollLeft(scrollLeft > 0);
        setCanScrollRight(scrollLeft < scrollWidth - clientWidth);
    };

    //updating position
    useEffect(() => {
        const ref = scrollref.current;
        if (!ref) return;
        checkScrollPosition();
        ref.addEventListener('scroll', checkScrollPosition);
        return () => ref.removeEventListener('scroll', checkScrollPosition);
    }, []);

    const [i , setI] = useState(0);

    const isMobile = useMediaQuery("(max-width:768px)");
    return (
        isMobile ?
        <div id="Training" className="z-10 relative flex flex-col items-center  gap-[7.407vh] justify-center my-[29.62vh]">
                <h4 className='flex flex-col items-center font-bold text-center px-4 s:text-[2rem] xs:text-[1.75rem] text-stone-700'>
                    Start learning Modern IT with 
                <img src={src} alt='bridge-labs' className='s:h-[48px]  xs:h-[40px]'></img>
                </h4>
            
                <div className='mx-[48px] flex flex-col xs:gap-4 s:gap-8 rounded-[16px] bg-white border-[1px] border-stone-200 hover:shadow-card cursor-pointer transition-shadow duration-300  ease-in justify-between items-center pt-4 max-w-[432px] min-[256px] w-[70vw]  pb-12'>
                    <div  className='flex justify-center h-[192px]  px-4 items-center w-full '>
                        <img src={`${i}.png`} className='max-h-[192px]' alt='icons'></img>
                    </div>
                    <h6 className='font-semibold px-[16px] h-16 text-stone-950 xs:text-[1.5rem] s:text-[1.75rem] text-center w-full'>{titles[i]}</h6>
                    <p className='font-medium bg-orange-300 xs:text-[1.125rem] s:text-[1.5rem] py-1 rounded-[8px] xs:w-[192px] s:w-[240px] h-fit text-center text-orange-600'>
                        {descriptions[i]}
                    </p>
                </div>
            {/* show left chevron */}
            {i>0 && (
                <ChevronLeft 
                    transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}}
                    size={40} 
                    onClick={() => setI(i-1)}
                    color="#44403C" 
                    className='absolute top-[60%] left-1 cursor-pointer hover:scale-110 transition-all duration-300'
                />
            )}

            {/* show right chevron */}
            {i<9 && (
                <ChevronRight 
                    transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}}
                    size={40} 
                    onClick={() => setI(i+1)}
                    color="#44403C" 
                    className='absolute top-[60%] right-1 cursor-pointer hover:scale-110 transition-all duration-300'
                />
            )}
        </div>
        :
        <div id="Training" className="z-10 relative flex flex-col  gap-[7.407vh] justify-center my-[29.62vh]">
                <motion.h4 viewport={{ once: true }}  initial={{opacity:0,y:-50}} whileInView={{opacity:1,y:0}} transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}} className='flex flex-col items-center font-bold text-[2.1875vw] text-stone-700'>
                    Start learning Modern IT with 
                <img src={src} alt='bridge-labs' className='h-[5.555vh]'></img>
                </motion.h4>
            
             <motion.div ref={scrollref} viewport={{ once: true }}  initial={{opacity:0,y:50}} whileInView={{opacity:1,y:0}} transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}}  className='mx-[7.17vw] p-[1vw] flex h-fit no-scrollbar overflow-x-scroll gap-[1.927vw] flex-nowrap '>
                {Array.from({length:10}).map((_,i)=>(
                            <div key={i} className='flex flex-col rounded-[0.729vw] bg-white border-[1px] border-stone-200 hover:shadow-card cursor-pointer transition-shadow duration-300  ease-in justify-between items-center pt-[2.222vh] pb-[4.444vh] min-w-[15vw] w-[15vw] h-[35.555vh]'>
                                <div  className='flex justify-center h-[11.481vh] px-[3.333vw] items-center w-full '>
                                    <img src={`${i}.png`} className='max-h-[11.481vh]' alt='icons'></img>
                                </div>
                                <h6 className='font-semibold px-[1.666vw] h-[6.66vh] text-stone-950 text-[1.041vw] text-center w-full'>{titles[i]}</h6>
                                <p className='font-medium bg-orange-300 text-[0.833vw] py-1 rounded-[0.416vw] w-[8.333vw] h-fit text-center text-orange-600'>
                                    {descriptions[i]}
                                </p>
                            </div>
                ))}
             </motion.div>
            {/* show left chevron */}
            {canScrollLeft && (
                <ChevronLeft 
                    transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}}
                    size={40} 
                    onClick={() => scrollref.current.scrollBy({ left: -5000, behavior: "smooth" })}
                    color="#44403C" 
                    className='absolute top-[60%] left-1 cursor-pointer hover:scale-110 transition-all duration-300'
                />
            )}

            {/* show right chevron */}
            {canScrollRight && (
                <ChevronRight 
                    transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}}
                    size={40} 
                    onClick={() => scrollref.current.scrollBy({ left: 5000, behavior: "smooth" })}
                    color="#44403C" 
                    className='absolute top-[60%] right-1 cursor-pointer hover:scale-110 transition-all duration-300'
                />
            )}
        </div>
    )
}